import * as angular from 'angular';
import { BackupMetadata, ComponentDefinition } from '../../models';
import { IFrequencyFormatHelperService } from '../../services/helpers';

class BackupMetadataController implements angular.IComponentController {
    copy: BackupMetadata;
    formatedFrequency: string;
    isLoading: boolean;

    readonly metadata: BackupMetadata;
    static $inject = ['frequencyFormatHelperService'];
    constructor(private _frequencyFormatHelper: IFrequencyFormatHelperService) {
    }


    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['metadata']) {
            const cv: BackupMetadata = changesObj['metadata'].currentValue;
            const copy = angular.copy(cv);
            this.formatedFrequency = this._frequencyFormatHelper.formatFrequency(cv.frequency);
            this.copy = copy;
        }
    }
}

export const wtBackupMetadata: ComponentDefinition = {
    componentId: 'wtBackupMetadata',
    controller: BackupMetadataController,
    controllerAs: 'vm',
    template: require('./backupMetadata.component.html'),
    bindings: {
        metadata: '<'
    }
};